import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let titleSceneC: any = null;
export default function C() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.SHP2');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }

                // maskSceneC = AniContainer.create({
                //     asyncFromTo: [['.shp2-detail-C .mask', { opacity: 0 }, { opacity: 1 }]],
                //     triggerElement: '.shp2-detail-C',
                //     triggerHook: 1,
                //     offset: window.innerHeight,
                //     duration: window.innerHeight / 2,
                // });

                // titleSceneC = AniContainer.create({
                //     asyncFromTo: [['.shp2-detail-C .title', { opacity: 0, y: window.innerHeight / 4 }, { opacity: 1, y: 0 }]],
                //     triggerElement: '.shp2-detail-C',
                //     triggerHook: 1,
                //     offset: window.innerHeight * 1.5,
                //     duration: window.innerHeight / 2,
                // });

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                titleSceneC = AniContainer.create({
                    triggerElement: '.shp2-detail-C .sticky-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-C shp2-detail-section ${css['shp2-detail-C']}`}>
            <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                <div className="img-box">
                    <EFPicture src={'/responsive/picture/smart-home-panel-2/launch/3.jpg'} alt={t('secC_title')} />
                    <div className="mask"></div>
                    <div className="title-box">
                        <h2 className="title">{t('secC_title')}</h2>
                    </div>
                </div>
            </div>
        </section>
    );
}
